import { render, staticRenderFns } from "./ModalChangeDateTerapia.vue?vue&type=template&id=cb1b2082"
import script from "./ModalChangeDateTerapia.vue?vue&type=script&lang=js"
export * from "./ModalChangeDateTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports